/**
 * Quick Pay Analytics Events
 * Centralized analytics event names for tracking
 */
export const QuickPayAnalyticsEvents = {
  AUTH_SUCCESS: 'quick_payment_auth_success',
  AUTH_FAILED: 'quick_payment_auth_failed',
  GOOGLE_LOGIN_INITIATED: 'quick_payment_google_login',
  PROPERTY_SELECTED: 'quick_payment_property_selected',
  PAYMENT_INITIATED: 'quick_payment_initiated'
} as const;

/**
 * Quick Pay Authentication Methods
 * Used for analytics tracking to identify auth flow
 */
export const QuickPayAuthMethod = {
  CREDENTIALS: 'credentials',
  GOOGLE: 'google',
  ACCOUNT_NUMBER: 'account_number'
} as const;

/**
 * Quick Pay Session Storage Keys
 */
export const QuickPayStorageKeys = {
  GOOGLE_AUTH_FLAG: 'quickPayGoogleAuth',
  SELECTED_PROPERTY: 'quickPaySelectedProperty',
  GOOGLE_AUTH_PROPERTIES: 'quickPayGoogleAuthProperties'
} as const;

/**
 * Quick Pay Error Codes
 * Predefined error codes to prevent XSS via query params
 */
export const QuickPayErrorCodes = {
  GOOGLE_SSO_FAILED: 'google_sso_failed',
  NO_PROPERTIES: 'no_properties'
} as const;

/**
 * Quick Pay Error Messages
 * User-facing error messages (consider i18n for production)
 */
export const QuickPayErrorMessages = {
  INVALID_CREDENTIALS:
    'Sorry, your credentials are invalid. Please try again or contact customer support.',
  INVALID_ACCOUNT_NUMBER:
    'Sorry, your account number is invalid. Please try again or contact customer support.',
  GOOGLE_SIGN_IN_FAILED: 'Google sign-in failed. Please try again.',
  UNABLE_TO_RETRIEVE_PROPERTIES:
    'Unable to retrieve your properties. Please try again or contact customer support.',
  NO_PROPERTY_SELECTED: 'Please select a property before confirming.',
  ONLINE_PAYMENT_UNAVAILABLE:
    'Online payment is not available for the community.',
  NO_PROPERTIES_FOUND:
    'No properties found for your account. Please contact customer support if you believe this is an error.'
} as const;

/**
 * Quick Pay View Modes
 */
export type QuickPaymentViewMode = 'credentials' | 'account-number';

/**
 * Property data for route state transfer (avoiding PII in URL)
 */
export interface QuickPayPropertyState {
  communityId: number;
  customerId: string;
  communityName: string;
  propertyAddress: string;
}
